import { OpenItem } from '@/components/pages/mobile-app/OpenItem'

const OpenRecipe = () => <OpenItem itemType="recipe" />

export default OpenRecipe
